import Vue from 'vue'
// resources
import EntitiesResource from '../../resources/entities'
import UserResource from '../../resources/user'
import UserRoleResource from '../../resources/userRolesMx'
import ApproverResource from '../../resources/approver'
import userFormSet from '../../resources/formsets/user'
import userRoleFormSet from '../../resources/formsets/user_roles_mx'
import approverFormSet from '../../resources/formsets/approver'
// components&views
import FormResourceEdit from '../../components/form_resource_edit/FormResourceEdit.vue'
import AutoComplete from '../../components/Autocomplete'
import ApproversGrid from '../../components/approvers_grid/ApproversGrid.vue'
import UsersGrid from '../../components/users_grid/UsersGrid.vue'
import UserRolesGrid from '../../components/user_roles_mx_grid/UserRolesMxGrid.vue'
// mixins
import toastMixin from '../../mixins/toast'
import modalMixin from '../../mixins/modal'

export default Vue.extend({
    data() {
        return {
            userResource: null,
            userRolesResource: null,
            approverResource: null,
            entityResource: null,
            isSavingUser: false,
            isSavingUserRole: false,
            isSavingApprover: false,
            recentlyCreatedUserId: null,
            userForm: false,
            userRoleForm: false,
            approverForm: false,
        }
    },
    mixins: [toastMixin, modalMixin],
    props: ['entityId'],
    components: {
        ApproversGrid,
        AutoComplete,
        FormResourceEdit,
        UsersGrid,
        UserRolesGrid,
    },
    computed: {
        formsets() {
            return {
                userFormSet,
                userRoleFormSet,
                approverFormSet,
            }
        },
    },
    methods: {
        displayNewUserForm() {
            if (this.entityId) {
                this.userResource = new UserResource()
                this.userForm = true
                this.userRoleForm = false
                this.approverForm = false
                this.showModal('create-user')
            } else {
                this.createToast('b-toaster-top-center', 'danger', true, 'Select Entity', 'Please search and select for an Entity.')
            }
        },
        async displayNewUserRoleForm(newUserId) {
            this.userRoleForm = !this.userRoleForm
            this.recentlyCreatedUserId = newUserId
            this.userResource = await UserResource.detail(this.recentlyCreatedUserId)
            this.entityResource = await EntitiesResource.detail(this.entityId)
            this.userRolesResource = new UserRoleResource()
            this.userRolesResource.set('user_id', this.userResource.attributes.username) //set the user name for user roles form
            this.userRolesResource.set('entity_id', this.entityResource.attributes.name) //set the entity name for the user roles form
        },
        displayNewApproverForm() {
            this.approverForm = !this.approverForm
            this.approverResource = new ApproverResource()
            this.approverResource.set('entity_id', this.entityResource.attributes.name) //set entity name for approver form
            this.approverResource.set('user_id', this.userResource.attributes.username) //set user name for approver form
        },
        saveNewUser() {
            let errors = this.userResource.validate()

            if (errors.length) {
                this.handleErrors(errors)
            } else {
                this.isSavingUser = !this.isSavingUser
                this.userResource.set('access', 1)
                this.userResource.set('isNewUser', true)
                this.userResource
                    .save()
                    .then((result) => {
                        if (result.response.status > 200 || result.response.status < 299) {
                            this.createToast('b-toaster-top-center', 'success', true, 'User Created', 'A new user was created')
                        }

                        this.displayNewUserRoleForm(result.response.data.id)
                        this.userForm = !this.userForm
                    })
                    .catch(() => {
                        this.createToast('b-toaster-top-center', 'danger', true, 'User Creation Error', 'Error creating user.  User may already exist.')
                    })
                    .finally(() => {
                        this.isSavingUser = !this.isSavingUser
                    })
            }
        },
        saveUserRoles() {
            this.userRolesResource.set('user_id', this.recentlyCreatedUserId)
            this.userRolesResource.set('entity_id', this.entityResource.attributes.id)

            let errors = this.userRolesResource.validate()

            if (errors.length) {
                this.handleErrors(errors)
            } else {
                this.isSavingUserRole = !this.isSavingUserRole
                this.userRolesResource
                    .save()
                    .then((result) => {
                        if (result.response.status > 200 || result.response.status < 299) {
                            this.createToast('b-toaster-top-center', 'success', true, 'User Role Created', `Role was added for ${this.recentlyCreatedUserId}`)
                        }
                        this.displayNewApproverForm()
                        this.userRoleForm = !this.userRoleForm
                    })
                    .catch(() => {
                        this.createToast('b-toaster-top-center', 'danger', true, 'User Role Creation Error', `Error createing role for ${this.recentlyCreatedUserId}`)
                    })
                    .finally(() => {
                        this.isSavingUserRole = !this.isSavingUserRole
                    })
            }
        },
        saveApprover() {
            this.approverResource.set('user_id', this.recentlyCreatedUserId)
            this.approverResource.set('entity_id', this.entityResource.attributes.id)
            this.approverResource.set('send_notifications', 1)
            this.approverResource.set('status', 1)

            let errors = this.approverResource.validate()

            if (errors.length) {
                this.handleErrors(errors)
            } else {
                this.isSavingApprover = !this.isSavingApprover
                this.approverResource
                    .save()
                    .then((result) => {
                        if (result.response.status > 200 || result.response.status < 299) {
                            this.createToast('b-toaster-top-center', 'success', true, 'Approver Created', `Role was added for ${this.recentlyCreatedUserId}`)
                        }
                        this.approverForm = !this.approverForm
                    })
                    .catch(() => {
                        this.createToast('b-toaster-top-center', 'danger', true, 'Approver Creation Error', `Error createing role for ${this.recentlyCreatedUserId}`)
                    })
                    .finally(() => {
                        this.isSavingApprover = !this.isSavingApprover
                        this.closeModal('create-user')
                    })
            }
        },
        skipForm(currentForm) {
            // opens the next form.
            if (currentForm == 'userForm') {
                this.userForm = false
                this.userRoleForm = true
            } else if (currentForm === 'userRoleForm') {
                this.userRoleForm = false
                this.approverForm = true
            } else {
                this.approverForm = false
            }
        },
    },
    mounted() {
        this.autoCompleteResource = EntitiesResource
    },
})
